import { authAxios } from "src/libs/axios/authAxios";
import {
  IGetMyServiceListReq,
  IGetMyServiceListRes,
} from "./types/console.type";

export const getMyServiceList = async (
  req: IGetMyServiceListReq
): Promise<IGetMyServiceListRes[]> => {
  const { product } = req;
  const response = await authAxios.get(
    `/wapi/cloud/service/list?product=${product}`
  );
  return response.data;
};
